import { FilterInput, SortOrder, useIntersectionListQuery } from '@kinetic-ui/data-layer';
import {
  useInfiniteLoaderQuery,
  getColumnSortParams,
  SortParams,
  usePagination,
  useGetNodes,
} from '@kinetic-ui/shared';
import { useRef, useState, useCallback } from 'react';

// override sort field value from the column key.
const sortFields: Record<string, SortOrder> = {};

export const useSelectSignalsData = ({
  searchText,
  filters,
}: {
  searchText: string;
  filters: FilterInput[];
}) => {
  const scrollReference = useRef<HTMLDivElement>(null);
  const onPreviousRef = useRef<() => void>();
  const onNextRef = useRef<() => void>();

  const [sort, setSort] = useState<SortParams>({
    field: 'name',
    order: SortOrder.Ascending,
  });

  const onSortChange = useCallback((newSort: Record<string, SortOrder>) => {
    if (Object.keys(newSort).length !== 0) {
      const sortedColumn = Object.keys(newSort)[0];
      const order = newSort[sortedColumn];
      const field = sortFields[sortedColumn] ?? sortedColumn;
      setSort({ field, order });
    }
  }, []);

  const { limit } = usePagination({
    onPrevious: onPreviousRef.current,
    scrollRef: scrollReference,
    onNext: onNextRef.current,
  });

  const { data, InViewComponent, infiniteFooter } = useInfiniteLoaderQuery(
    useIntersectionListQuery,
    'intersections',
    'intersectionListQuery',
    {
      sortOrder: sort.order,
      sortField: sort.field,
      after: null,
      searchText,
      filters,
      limit,
    }
  );

  const signals = useGetNodes(data?.intersections);

  return {
    signals,
    onSortChange,
    sort: getColumnSortParams(sort, sortFields),
    InViewComponent,
    infiniteFooter,
  };
};
